import ChatContainer from './styled';

export default ChatContainer;
